import React from 'react';
import {
  SimpleGrid,
  Button,
  Icon,
  Text,
  Box,
  IconButton,
} from '@chakra-ui/react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';

export const SecaoUploadImagens = ({
  imagens,
  abrirModalImagem,
  removerImagem,
  carregarFotos,
  carregando,
  cores,
}) => {
  return (
    <SimpleGrid columns={{ base: 2, md: 4, lg: 6 }} spacing={4}>
      {imagens.length < 10 && (
        <Button
          height="120px"
          variant="outline"
          borderStyle="dashed"
          borderColor={cores.corBorda}
          _hover={{ bg: cores.fundoSecaoIA, borderColor: 'blue.400' }}
          onClick={carregarFotos}
          flexDirection="column"
          isLoading={carregando}
          isDisabled={carregando}
        >
          <Icon as={FiPlus} mb={2} />
          <Text fontSize="xs">Upload Fotos</Text>
        </Button>
      )}
      {imagens.map((img, idx) => (
        <Box
          key={img.id}
          height="120px"
          borderRadius="md"
          border="1px"
          borderColor={cores.corBorda}
          overflow="hidden"
          position="relative"
          role="group"
          cursor="pointer"
          onClick={() => abrirModalImagem(idx)}
        >
          <img
            src={img.url}
            alt="Preview"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <IconButton
            aria-label="Remover"
            icon={<FiTrash2 />}
            size="xs"
            colorScheme="red"
            position="absolute"
            top="1"
            right="1"
            opacity="0"
            _groupHover={{ opacity: '1' }}
            onClick={e => {
              e.stopPropagation();
              removerImagem(img.id);
            }}
          />
        </Box>
      ))}
    </SimpleGrid>
  );
};
